import { render, staticRenderFns } from "./ExternalPluginReports.vue?vue&type=template&id=537c3305&scoped=true"
import script from "./ExternalPluginReports.vue?vue&type=script&lang=js"
export * from "./ExternalPluginReports.vue?vue&type=script&lang=js"
import style0 from "./ExternalPluginReports.vue?vue&type=style&index=0&id=537c3305&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537c3305",
  null
  
)

export default component.exports